import { sentryCreateBrowserRouter } from '@/lib';

import { mainRoute } from './main-route';
import { authRoute } from './auth-route';
import { notFoundRoute } from './not-found-route';

export const router = sentryCreateBrowserRouter([mainRoute, authRoute, notFoundRoute], {
  basename: ENV.BASE_PUBLIC_PATH,
});
